export default __webpack_public_path__ + "static/avatar-alex-allan2-3f832151604604cceca8d39f0fe4880f.webp";